module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (this.$store.state.is_auth) ? _c('div', [(!_vm.form_ErrorMessage) ? [_c('h4', {
    staticClass: "qa-search-field-title"
  }, [_vm._v(_vm._s(_vm._f("ftc")('qa/any_questions')))]), _vm._v(" "), _c('div', {
    staticClass: "support-block-wrapper search"
  }, [_c('Field', {
    ref: "qaSearch",
    attrs: {
      "isVisibleRow": true,
      "crud": "qa",
      "action": "list",
      "name": "qaSearch",
      "Field": {
        _field_name: 'qaSearch',
        type: 'text',
        title: 'main/qa_search',
        '_visible': true
      },
      "removeRightPadding": true,
      "clearButton": true,
      "bigButton": true,
      "bigButtonTitle": 'main/ask'
    },
    on: {
      "event_ClearButtonClicked": _vm.qaSearchEvent,
      "enterKeyDown": _vm.qaSearchStart,
      "event_Input": _vm.onTextEvent
    },
    model: {
      value: (_vm.qaSearchValue),
      callback: function($$v) {
        _vm.qaSearchValue = $$v
      },
      expression: "qaSearchValue"
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', {
    staticClass: "qa-tags-cloud-title"
  }, [_vm._v(_vm._s(_vm._f("ftc")('qa/popular_topics')))]), _vm._v(" "), (_vm.tagList) ? _c('div', {
    staticClass: "support-tag-cloud"
  }, _vm._l((_vm.tagList), function(tag) {
    return _c('div', {
      staticClass: "tag"
    }, [_c('a', {
      attrs: {
        "href": _vm.QAURL + '/tags/' + encodeURIComponent(tag.tag),
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(tag.tag))])])
  }), 0) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "support-block-wrapper"
  }, [(_vm.popList) ? _c('div', {
    staticClass: "support-block-questions first"
  }, [_c('h4', [_vm._v(_vm._s(_vm._f("ftc")('qa/pop_questions')))]), _vm._v(" "), _c('ul', _vm._l((_vm.popList), function(link) {
    return _c('li', [_c('a', {
      attrs: {
        "href": _vm.QAURL + '/q/' + link.url,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(link.cap))])])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.newList) ? _c('div', {
    staticClass: "support-block-questions"
  }, [_c('h4', [_vm._v(_vm._s(_vm._f("ftc")('qa/new_questions')))]), _vm._v(" "), _c('ul', _vm._l((_vm.newList), function(link) {
    return _c('li', [_c('a', {
      attrs: {
        "href": _vm.QAURL + '/q/' + link.url,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(link.cap))])])
  }), 0)]) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "support-block-wrapper"
  }, [_c('router-link', {
    staticClass: "w5-support-link",
    attrs: {
      "to": "/ticket/create"
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "question-circle"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "header"
  }, [_vm._v(_vm._s(_vm._f("ftc")('qa/ticket_question')))]), _vm._v(" "), _c('span', {
    staticClass: "link-title"
  }, [_vm._v(_vm._s(_vm._f("ftc")('qa/create_ticket')))])], 1)], 1)] : _vm._e()], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-777acdb0"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/crud/QA.vue
// module id = 709
// module chunks = 0